import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
var back = normalize.back(function (options) {
  var _ref = options || {},
    _success = _ref.success,
    _fail = _ref.fail,
    _complete = _ref.complete;
  swan.navigateBack({
    delta: 1,
    success: function success() {
      _success && _success();
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, CONTAINER_NAME.BAIDU);
export default back;